import React, { useEffect, useRef, useState } from 'react';
import { browserHistory } from 'react-router';
import moment from 'moment';
import Header from '../../../components/Header.js';
import ArrowRightIcon from '../../../assets/images/arrow-right-bold-outline-custom.png';
import Scanner from '../../../components/commonComponents/Scanner/Scanner';
import { getSetProductContents } from '../../../utils/utils.js';
import withNotify from '../../../common/withNotify.js';
import Bugsnag from '../../../helpers/bugsnag.js';
import withLoader from '../../../common/withLoader.js';
import withSetsToMove from '../../../common/withSetsToMove.js';
import { screenWidth } from '../../../common/globals.js';
import OptimizeModal from '../../../components/commonComponents/OptimizeModal.js';
import { useSDK } from '../../../components/commonComponents/Scanner/components/sdk';

function MoveSets(props) {
  const [scanPaused, setScanPaused] = useState(true);
  const [sets, setSets] = useState([]);
  const setsRef = useRef();
  setsRef.current = sets;
  const [showModal, setShowModal] = useState(false);
  const [showSetScannedModal, setShowSetScannedModal] = useState(false);
  const { loading, sdk } = useSDK();
  const [setsContentModalData, SetsContentModalData] = useState([]);
  const [setContentModalModal, setSetContentModalModal] = useState(false);

  const onScan = async (data, currentSets) => {
    props.setLoader(true);
    try {
      const res = await getSetProductContents({ barcode: data });
      if (!res.locations) {
        props.notify({ type: 'error', message: res.message });
        return;
      }
      if (res.locations.length === 0) {
        setShowModal(true);
        return;
      }
      const setData = res.locations[0];
      if (currentSets.find((set) => set.SetName === setData.SetName)) {
        setShowSetScannedModal(true);
        return;
      }
      setSets((localSets) => [...localSets, setData]);
      // console.log(setData);
      const currentDate = moment();
      if (moment(setData.NextDate).isAfter(currentDate)) {
        setSetContentModalModal(true);
        SetsContentModalData(setData);
      }
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      props.setLoader(false);
    }
  };

  const onRemoveSet = (currentSets, index) => {
    const newSets = [...currentSets];
    newSets.splice(index, 1);
    setSets(newSets);
  };

  const onMove = () => {
    const { setSetsToMove } = props;
    if (sets.length === 0) {
      props.notify({ type: 'error', message: 'Please scan at least one set first.' });
      return;
    }
    setSetsToMove(sets);
    browserHistory.push('/move-sets-to-location');
  };

  const onSaveSetContentModal = () => {
    // const { setSetsToMove } = props;
    // setSetsToMove(sets);
    setSetContentModalModal(false);
    // browserHistory.push('/move-sets-to-location');
  };

  const onRemoveSetContentModal = () => {
    setSetContentModalModal(false);
    setSets([]);
  };

  useEffect(() => {
    if (loading) return;
    if (scanPaused) {
      sdk.enableScanning(false);
    } else {
      sdk.enableScanning(true);
    }
  }, [scanPaused, loading]);

  return (
    <div>
      <OptimizeModal
        show={showSetScannedModal} id="setAlreadyScannedModal"
        modalBody={(
          <p>Set already scanned.</p>
        )}
        modalFooter={(
          <div className="row gx-2 button-wrap">
            <div className="col-12">
              <button
                type="button" className="btn btn-link w-100 pt-3"
                onClick={() => setShowSetScannedModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
      />
      <OptimizeModal
        show={showModal} id="barcodeNotFoundModal"
        modalBody={(
          <>
            <p>Set barcode not found.</p>
            <p>Please scan another barcode or move the set manually from the Set Status screen.</p>
          </>
        )}
        modalFooter={(
          <div className="row gx-2 button-wrap">
            <div className="col-12">
              <button
                type="button" className="btn btn-link w-100 pt-3"
                onClick={() => setShowModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
      />
      <Header
        title="Move Sets"
        goBack={() => browserHistory.goBack()}
        customRightSide={(
          <button
            className="btn header-btn sub-header-text btn-ml"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '5px',
              color: 'var(--primary-color)',
              width: '100%',
              margin: '0px',
            }}
            onClick={onMove}
          >
            Move
            <img
              style={{
                width: '20px',
              }}
              src={ArrowRightIcon}
              alt="arrow-right"
            />
          </button>
        )}
      />
      <section
        className={`${screenWidth <= 800 ? 'camera-wrap-small' : null}`}
      >
        {!loading && (
          <Scanner
            style={{ maxWidth: 650, margin: 'auto' }}
            onScan={(data) => onScan(data, setsRef.current)}
            paused={scanPaused}
            setPaused={setScanPaused}
          />
        )}
      </section>
      <div className="container">
        <section style={{ marginBottom: 70 }}>
          <div
            className="sets-count" style={{
              padding: '10px 0px',
              borderBottom: '1px solid #757575',
            }}
          >
            Sets: {sets.length}
          </div>
          <table className="sets-table table">
            <thead>
              <tr>
                <th style={{ width: '10%' }}>#</th>
                <th>Set</th>
              </tr>
            </thead>
            <tbody>
              {sets.map((set, index) => (
                <tr key={index}>
                  <td>{set.SetNo}</td>
                  <td style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                  >
                    {set.SetName}{set.DeviceType === 'INSTRUMENT' && set.TrayCount
                      ? ` (${set.TrayCount} ${set.TrayCount > 1 ? 'Trays' : 'Tray'})` : null}
                    <a role="button" tabIndex={0} onClick={() => onRemoveSet(sets, index)}>
                      <i className="fa fa-trash" style={{ color: 'var(--primary-color)' }} />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <section
          className="bg-theme"
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            backgroundColor: 'var(--background-gray)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '15px 0px',
          }}
        >
          <button
            type="button"
            className={`btn btn-lg btn-theme-alt btn-theme-outline-alt w-25 ${!scanPaused ? 'active' : ''}`}
            onClick={() => setScanPaused(false)}
          >Scan
          </button>
        </section>
      </div>
      <OptimizeModal
        show={setContentModalModal}
        id="SetsContentModalModal"
        modalBody={(
          <div>
            <div style={{ color: '#000', fontSize: 14 }}>The scanned set is planned for an upcoming case. If possible, </div>
            <div style={{ color: '#000', fontSize: 14 }}>consider moving a different set.</div>

            <div style={{
              width: '100%', marginBottom: 2, padding: 10, color: '#000', fontSize: 14
            }}
            >
              <table>
                <tbody>
                  <tr>
                    <td width={100}>Next Case: </td>
                    <td>{setsContentModalData.NextCase}</td>
                  </tr>
                  <tr>
                    <td>Next Date: </td>
                    <td>{setsContentModalData.NextDate && moment(setsContentModalData.NextDate).format('L')}</td>
                  </tr>
                  <tr>
                    <td>Next Loc: </td>
                    <td>{setsContentModalData.NextLocName}</td>
                  </tr>
                  <tr>
                    <td>Next Rep: </td>
                    <td>{setsContentModalData.NextRep}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        modalFooter={(
          <div className="row gx-2">
            <div className="col-6">
              <button
                type="button"
                className="btn w-100 btn-gray"
                onClick={onRemoveSetContentModal}
                style={{ fontSize: 14, borderRadius: 5, color: '#eda340' }}
                data-dismiss="modal"
              >
                Delete
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn w-100 btn-gray"
                onClick={onSaveSetContentModal}
                style={{ fontSize: 14, borderRadius: 5, color: '#eda340' }}
                data-dismiss="modal"
              >
                Continue
              </button>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default withSetsToMove(
  withLoader(
    withNotify(
      MoveSets
    )
  )
);
